import { createSlice } from "@reduxjs/toolkit";
import { getEntityById, patchCoinEntity, postCoinEntity } from "./thunks";
import { CoinEntity, CoinEntityConfig, CoinEntityValidation } from "../../../entities/coinGame";

interface CoinFlipState {
  loading: boolean;
  saveLoading: boolean;
  entity?: CoinEntity;
  config?: CoinEntityConfig;
  validation?: CoinEntityValidation
}

const initialState: CoinFlipState = {
  loading: false,
  saveLoading: false,
};

export const coinFlipSlice = createSlice({
  name: "coinFlipEntity",
  initialState,
  reducers: {
    clearEntity: (state) => {
      state.entity = undefined;
      state.config = undefined;
      state.validation = undefined;
    }
  },
  extraReducers: (builder) => {
    // postCoinEntity - создание
    builder.addCase(postCoinEntity.pending, (state) => {
      state.loading = true;
      state.saveLoading = true;
    });
    builder.addCase(postCoinEntity.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.config = action.payload.config;
      state.validation = action.payload.validation;
      state.loading = false;
      state.saveLoading = false;
    });
    builder.addCase(postCoinEntity.rejected, (state) => {
      state.loading = false;
      state.saveLoading = false;
    });
    // getEntityById - получение
    builder.addCase(getEntityById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEntityById.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.config = action.payload.config;
      state.validation = action.payload.validation;
      state.loading = false;
    });
    builder.addCase(getEntityById.rejected, (state) => {
      state.loading = false;
    });
    // patchCoinEntity - изменение и обновление state
    builder.addCase(patchCoinEntity.pending, (state) => {
      state.saveLoading = true;
    });
    builder.addCase(patchCoinEntity.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.config = action.payload.config;
      state.validation = action.payload.validation;
      state.saveLoading = false;
    });
    builder.addCase(patchCoinEntity.rejected, (state) => {
      state.saveLoading = false;
    });
  },
});
// export actions
export const { clearEntity } = coinFlipSlice.actions;

export default coinFlipSlice.reducer;
